import Vue from 'vue'
import Vuex from 'vuex'

import Task from './modules/task'
import About from './modules/about'
import Fdback from './modules/fdback'
import StuFdback from './modules/stufdback'
import Class from './modules/class'
import User from './modules/user'
import weeklySurvey from './modules/weeklySurvey'

import WinterCamp from './modules/winter-camp'

import actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

const state = {
    message: '',
    env: process.env,
    onXHR: false,
}

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    state,
    actions,
    mutations,
    modules: {
        Task,
        About,
        Fdback,
        StuFdback,
        Class,
        User,          
        WinterCamp,
        weeklySurvey
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js